type ElementProps = {
  title: string;
  value: string;
  truncate?: boolean;
};

export const Element = ({ title, value, truncate = true }: ElementProps) => {
  return (
    <div className="flex flex-row justify-center gap-2 border-b border-gray-200 py-3">
      <h3 className="flex-1 text-xs font-medium text-gray-600 md:text-sm">{title}</h3>
      <p
        className={`md:text-normal flex-1 text-sm ${truncate ? "truncate" : ""} font-medium text-gray-700`}
      >
        {value}
      </p>
    </div>
  );
};
